


export default {

    mixins:[],
    props: {
        value: {
          type: Array
        }
    },
    inject: ['$validator'],
    components: {

    },
    data : function(){

        return {


        };
    },

    watch:{


    },

    mounted : function ()
    {
    },

    methods:{
        update()
        {
            this.$emit('input', this.consents);
        }
    },
    computed: {

        consents: {

          get: function() {
            return this.value;
          },
          set: function(modifiedValue) {
            this.$emit('input', modifiedValue);
          },

        },
  }

}
